// extracted by mini-css-extract-plugin
export default {"container":"CountdownTimer_container__1dCIm","time":"CountdownTimer_time__0RhqF"};